// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"181":"e3cef8c0","241":"b3c5f151","440":"c72d122c","508":"0c7baf48","535":"f0ba2572","653":"26c22cb6","690":"a9f6fb51","704":"604f7503","794":"f159de62"}[chunkId] + ".chunk.js";
};